import { InitOptions } from 'i18next';

import en from '@24i/prd-localization-files-moltv-01/dist/en.json';
import id from '@24i/prd-localization-files-moltv-01/dist/id.json';
import it from '@24i/prd-localization-files-moltv-01/dist/it.json';
import zh from '@24i/prd-localization-files-moltv-01/dist/zh.json';
import ms from '@24i/prd-localization-files-moltv-01/dist/ms.json';

export const i18nOptions: Partial<InitOptions> = {
    resources: {
        en: { mol: en, sott: en },
        id: { mol: id, sott: id },
        it: { mol: it, sott: it },
        zh: { mol: zh, sott: zh },
        ms: { mol: ms, sott: ms },
    },
    defaultNS: 'mol',
    ns: ['mol'],
    react: {
        wait: true,
        useSuspense: false,
    },
    fallbackLng: 'en',
};
